import { Navigate, useLocation } from 'react-router-dom';
import { buildLegacyRedirectTarget } from './adsNavigation';

/**
 * legacy Ads route → canonical；保留 query／hash／state。
 */
export default function AdsLegacyRedirect({ from }) {
  const location = useLocation();
  const target = buildLegacyRedirectTarget(from, location.search, location.hash);
  if (!target) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={target} replace state={location.state} />;
}
